export default {
  data() {
    return {
      pageList: [
        {
          // 作業予定
          name: 'PWR01G01',
          compareArrData: {
            identifyKey: 'workingPlanAndResultRcId',
            keys: ['workPlanDateDay', 'workPlanEndTime', 'workPlanStartTime'],
          },
        },
        {
          //  作業実績
          name: 'PWR02G04',
          compareArrData: {
            identifyKey: 'workingPlanAndResultId',
            keys: [
              'resultWorkStartDate',
              'resultWorkStartTime',
              'resultWorkEndTime',
            ],
          },
        },
      ],
    }
  },
  computed: {
    submitList() {
      let list = this.$refs?.table?.dataSource || []
      let initTableList = this?.initTableList || []
      return this.getSubmitList(list, initTableList).length
    },
  },
  methods: {
    getSubmitList(list, originArr) {
      let keyData = this.pageList.find(
        (item) => item.name == this.$options.name
      )
      if (!keyData) {
        return []
      }
      let tableList = this.compareArr({
        originArr: this.$baseLodash.cloneDeep(originArr),
        targetArr: this.$baseLodash.cloneDeep(list),
        ...keyData.compareArrData,
      })

      return tableList.filter(
        (item) =>
          item.operationType == this.$divisions.operationTypeEnum.enum_U.value
      )
    },
  },
  mounted() {
    let keyData = this.pageList.find((item) => item.name == this.$options.name)
    if (keyData) {
      this.$watch(
        'submitList',
        (val) => {
          if (val) {
            this.btnUpdate[0].disabled = false
          } else {
            this.btnUpdate[0].disabled = true
          }
        },
        { immediate: true, deep: true }
      )
    }
  },
}
